import { render, staticRenderFns } from "./CourseWellbeing.vue?vue&type=template&id=3aba2923&scoped=true&"
import script from "./CourseWellbeing.vue?vue&type=script&lang=js&"
export * from "./CourseWellbeing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aba2923",
  null
  
)

export default component.exports